// zn.js
export default {
  appText: '云信IM H5',
  messageText: '消息',
  contactText: '通讯录',
  mineText: '我的',
  logoutText: '退出登录',
  commsEaseText: '关于云信',
  logoutConfirmText: '确定退出登录吗?',
  avatarText: '头像',
  updateAvatarText: '修改头像',
  accountText: '账号',
  name: '昵称',
  genderText: '性别',
  remarkText: '备注名',
  mobile: '手机',
  email: '邮箱',
  sign: '签名',
  man: '男',
  woman: '女',
  unknow: '未知',
  birthText: '生日',
  FriendPageText: '好友名片',
  startConversationText: '发起单聊',
  addText: '添加',
  removeText: '移除',
  addTeamManagerSuccessText: '添加管理员成功',
  addTeamManagerFailText: '添加管理员失败',
  confirmRemoveText: '是否移除？',
  removeManagerExplain: '移除后该成员将无管理权限',
  removeMemberExplain: '将移除该成员',
  removeSuccessText: '移除成功',
  removeFailText: '移除失败',
  userNotInTeam: '该用户不在群里',
  noTeamManager: '暂无群管理员',
  noTeamMember: '暂无群成员',
  applyFriendSuccessText: '好友申请已发送',
  applyFriendFailText: '发送申请失败',
  addFriendText: '添加好友',
  addMemberText: '添加成员',
  addFriendFailText: '添加好友失败',
  deleteFriendText: '删除好友',
  deleteFriendConfirmText: '是否确认删除好友',
  deleteFriendSuccessText: '删除好友成功',
  deleteFriendFailText: '删除好友失败',
  setBlackFailText: '加入黑名单失败',
  removeBlackFailText: '解除黑名单失败',
  removeBlackSuccessText: '解除黑名单成功',
  addPermissionText: '请在系统设置页添加相关权限',
  FailAvatarText: '上传头像失败',
  chooseDefaultImage: '选择默认图标',
  chatButtonText: '去聊天',
  gotoChatFailText: '去聊天失败',
  chatWithFriendText: '聊天',
  okText: '确定',
  updateText: '修改',
  cancelText: '取消',
  friendSelectText: '选择好友',
  telErrorText: '手机格式不正确',
  emailErrorText: '邮箱格式不正确',
  createButtonText: '创建',
  createP2PText: '发起单聊',
  createTeamText: '创建群聊',
  addTeamMemberText: '添加群成员',
  addTeamMemberFailText: '添加群成员失败',
  teamTitlePlaceholder: '请输入群名称',
  maxSelectedText: '最多只能选择200位好友',
  createTeamSuccessText: '创建群组成功',
  createTeamFailedText: '创建群组失败',
  PersonalPageText: '个人名片',
  deleteSessionText: '删除会话',
  sessionMuteText: '开启消息提醒',
  sessionMuteFailText: '开启消息提醒失败',
  sessionUnMuteFailText: '关闭消息提醒失败',
  stickTopText: '聊天置顶',
  deleteStickTopText: '取消置顶',
  addStickTopText: '置顶消息',
  deleteSessionFailText: '删除会话失败',
  deleteStickTopFailText: '取消置顶失败',
  addStickTopFailText: '置顶消息失败',
  teamMemberText: '群成员',
  teamIdText: '群号',
  teamManagerText: '群管理',
  teamManagerSettingText: '管理管理员',
  updateTeamInfoText: '谁可以编辑群信息',
  updateTeamInviteText: '谁可以邀请新成员',
  updateTeamAtText: '谁可以@所有人',
  transformTeam: '转让群主',
  transformTeamContent: '确认转让群主给',
  doubt: '吗？',
  transformTeamSuccessText: '转让群主成功',
  transformTeamFailedText: '转让群主失败',
  transformTeamText: '选择转让成员',
  teamBannedText: '群禁言',
  saveText: '保存',
  setText: '设置',
  failText: '失败',
  saveSuccessText: '保存成功',
  saveFailedText: '保存失败',
  searchTeamPlaceholder: '请输入群名称',
  nickInTeamEmptyText: '请输入群昵称',
  teamTitle: '群名称',
  teamInfoText: '群信息',
  teamIntro: '群介绍',
  teamAvatar: '群头像',
  networkError: '当前网络异常，请检查你的网络设置',
  searchFailText: '查找失败',
  offlineText: '当前网络不可用，请检查你当前网络设置。',
  connectingText: '当前IM连接已断开，正在重连...',
  teamMenuText: '我的群组',
  teamChooseText: '我的群聊',
  chooseText: '选择',
  friendSelect: '请选择联系人',
  pleaseSelectMember: '请选择成员',
  teamMemebrSelect: '人员选择',
  getHistoryMsgFailedText: '获取失败',
  getMergedForwardFailedText: '信息获取失败',
  deleteText: '删除',
  recallText: '撤回',
  copyText: '复制',
  forwardText: '转发',
  multiSelectText: '多选',
  oneByOneForwardText: '逐条转发',
  oneByOneForwardLimitText: '逐条转发限制10条消息',
  mergeForwardText: '合并转发',
  mergeForwardLimitText: '合并转发限制100条消息',
  forwardExceptionTitle: '异常说明',
  forwardExceptionContent: '存在不可转发的消息体, 是否去除后发送?',
  noForwardableMsgText: '没有可转发的消息',
  pleaseSelectMsgText: '请选择消息',
  forwardComment: '留言',
  forwardSuccessText: '转发成功',
  forwardFailedText: '转发失败',
  getMessageFailed: '获取消息失败',
  replyText: '回复',
  replyNotFindText: '该消息已撤回或删除',
  msgRecallTimeErrorText: '已超过时间无法撤回',
  enableV2CloudConversationText: '是否开启云端会话',
  SwitchToEnglish: '切换语言为英文',
  copySuccessText: '复制成功',
  copyFailText: '复制失败',
  tipText: '提示',
  selectImageText: '请选择图片文件',
  uikitVersion: '版本号',
  IMVersion: 'IM版本号',
  productInfoText: '产品介绍',

  forwardToTeamText: '转发到群组',
  forwardToFriendText: '转发到个人',
  sessionRecordText: '的会话记录',
  chatInputPlaceHolder: '说点什么呢~',
  pinText: '标记',
  pinFailedText: '标记失败',
  unpinText: '取消标记',
  unpinSuccessText: '已取消标记',
  unpinFailedText: '取消标记失败',
  noPinListText: '暂无标记消息',
  collectionText: '收藏',
  deleteCollectionText: '删除收藏',
  addCollectionSuccessText: '已收藏',
  addCollectionFailedText: '添加收藏失败',
  collectionLimitText: '收藏数已达到限制值',
  deleteCollectionConfirmText: '确认要删除该收藏吗？',
  deleteCollectionFailedText: '删除收藏失败',
  noCollectionsText: '暂无收藏',
  you: '你',
  pinThisText: '标记了这条消息',
  delete: '删除此消息',
  recall: '撤回了一条消息',
  recall2: '此消息已撤回',
  recall3: '撤回此消息',
  recallMsgFailText: '撤回消息失败',
  reeditText: '重新编辑',
  loadingMoreText: '加载更多……',
  noMoreText: '没有更多了',
  deleteMsgSuccessText: '删除成功',
  deleteMsgFailText: '删除失败',
  conversationEmptyText: '暂无会话',
  teamOwner: '群主',
  teamManager: '群管理员',
  manager: '管理员',
  teamEmptyText: '暂无群聊',
  blacklistEmptyText: '暂无黑名单',
  blacklistSubTitle: '你不会收到列表中任何联系人的消息',
  validEmptyText: '暂无验证消息',
  dismissTeamText: '解散群组',
  dismissTeamConfirmText: '是否确认解散该群组',
  leaveTeamTitle: '退出群聊',
  leaveTeamConfirmText: '是否确认退出该群组',
  leaveTeamSuccessText: '已成功退出此群',
  leaveTeamFailedText: '退出此群失败',
  dismissTeamSuccessText: '群解散成功',
  dismissTeamFailedText: '群解散失败',
  updateTeamSuccessText: '修改成功',
  updateTeamFailedText: '修改失败',
  teamTitleConfirmText: '群名称不能为空',
  teamIntroConfirmText: '群介绍不能为空',
  aliasConfirmText: '备注名不能为空',
  sendImageFailedText: '发送图片失败',
  sendVideoFailedText: '发送视频失败',
  sendAudioFailedText: '发送音频失败',
  sendFileFailedText: '发送文件失败',
  fileSizeLimitText: '当前文件大小超出 200 MB发送限制，请重新选择',
  sendMsgFailedText: '发送消息失败',
  weekText: '周前',
  dayText: '天前',
  hourText: '小时前',
  minuteText: '分钟前',
  nowText: '刚刚',
  sendText: '发送',
  sendToText: '发送给',
  textMsgText: '文本消息',
  audioMsgText: '语音消息',
  videoMsgText: '视频消息',
  fileMsgText: '文件消息',
  callMsgText: '话单消息',
  geoMsgText: '地理位置消息',
  imgMsgText: '图片消息',
  notiMsgText: '通知消息',
  robotMsgText: '机器消息',
  tipMsgText: '提示消息',
  customMsgText: '自定义消息',
  chatHistoryText: '聊天记录',
  messageOfText: '的消息',
  unknowMsgText: '未知消息体',
  noFriendText: '暂无好友',
  onDismissTeamText: '该群聊已解散',
  onRemoveTeamText: '您已离开群组',
  selectSessionFailText: '选择会话失败',
  noExistUser: '该用户不存在',
  enterAccount: '请输入账号',
  validMsgText: '验证消息',
  blacklistText: '黑名单',
  applyTeamText: '申请入群',
  acceptResultText: '已同意',
  rejectResultText: '已拒绝',
  rejectTeamInviteText: '拒绝了群邀请',
  beRejectResultText: '拒绝了好友申请',
  passResultText: '通过了好友申请',
  acceptedText: '已同意该申请',
  acceptFailedText: '同意该申请失败',
  rejectedText: '已拒绝该申请',
  rejectFailedText: '拒绝该申请失败',
  passFriendAskText: '我已经同意了你的申请，现在开始聊天吧~',
  applyFriendText: '添加您为好友',
  rejectText: '拒绝',
  acceptText: '同意',
  inviteTeamText: '邀请入群',
  addBlacklist: '加入黑名单',
  removeBlacklist: '解除',
  teamAll: '所有人',
  getHistoryFailedText: '获取历史消息失败',
  sendFailWithInBlackText: '对方已将你拉黑，消息发送失败',
  sendFailWithDeleteText: '双方关系已解除，如需沟通，请申请',
  friendVerificationText: '好友验证',
  chooseMentionText: '选择提醒',
  someoneText: '有人',
  meText: '我',
  teamMutePlaceholder: '当前群主已经设置为群禁言',
  noPermission: '您暂无权限操作',
  muteAllTeamFailedText: '全员禁言失败',
  unmuteAllTeamFailedText: '解除全员禁言失败',
  friendEditPlaceholder: '请输入备注名',

  nickInTeam: '我在群里的昵称',
  viewMoreText: '查看更多',
  resendMsgFailText: '重发失败',
  audioBtnText: '按住说话',
  audioRemindText: '松开发送',
  audioErrorText: '录音失败，请检查是否开启权限',
  videoPlayText: '视频播放',
  updateTeamAvatar: '更新了群头像',
  updateTeamName: '更新群名称为',
  updateTeamIntro: '更新了群介绍',
  updateTeamInviteMode: '更新了群权限“邀请他人权限”为',
  updateTeamUpdateTeamMode: '更新了群权限“群资料修改权限”为',
  updateAllowAt: '更新了“@所有人权限”为',
  updateTeamMute: '更新了“群禁言”为',
  onlyTeamOwner: '仅群主',
  teamOwnerAndManagerText: '群主和管理员',
  closeText: '关闭',
  openText: '开启',
  joinTeamText: '加入群组',
  leaveTeamText: '离开了群组',
  beRemoveTeamText: '被移出群组',
  beAddTeamManagersText: '被任命为管理员',
  beRemoveTeamManagersText: '被移除管理员',
  newGroupOwnerText: '成为新群主',
  callDurationText: '通话时长',
  callCancelText: '已取消',
  callRejectedText: '已拒绝',
  callTimeoutText: '超时未接听',
  callBusyText: '忙线未接听',
  callFailedText: '呼叫失败',
  wxAppFileCopyText: '已自动复制网址，请在手机浏览器里粘贴该网址',
  shootText: '拍摄',
  albumText: '相册',
  voiceCallText: '语音通话',
  videoCallText: '视频通话',
  msgReadPageTitleText: '消息阅读状态',
  readText: '已读',
  unreadText: '未读',
  fileText: '文件',
  allUnReadText: '全部成员未读',
  allReadText: '全部成员已读',
  searchText: '请输入你要搜索的关键字',
  searchTitleText: '搜索',
  friendText: '好友',
  teamText: '群组',
  searchResultNullText: '该用户不存在',
  conversationSendFailText: '[发送失败]',
  conversationNotificationText: '[通知消息]',
  getForwardMessageFailed: '该消息已撤回或删除',
  fileMsgTitleText: '[文件消息]',
  collectionFromText: '来自',
  openUrlText: '已复制链接，请在浏览器打开链接',
  SwitchToEnglishText: '是否切换为英文',
  securityTipText: '仅用于体验云信产品功能，请勿轻信汇款、中奖等涉及钱款的信息，勿拨打陌生电话，谨防受骗。',
  sendToFriend: '发送给好友',
  sendToTeam: '发送给群聊',
  // emoji 不能随便填，要用固定 key
  Laugh: '[大笑]',
  Happy: '[开心]',
  Sexy: '[色]',
  Cool: '[酷]',
  Mischievous: '[奸笑]',
  Kiss: '[亲]',
  Spit: '[伸舌头]',
  Squint: '[眯眼]',
  Cute: '[可爱]',
  Grimace: '[鬼脸]',
  Snicker: '[偷笑]',
  Joy: '[喜悦]',
  Ecstasy: '[狂喜]',
  Surprise: '[惊讶]',
  Tears: '[流泪]',
  Sweat: '[流汗]',
  Angle: '[天使]',
  Funny: '[笑哭]',
  Awkward: '[尴尬]',
  Thrill: '[惊恐]',
  Cry: '[大哭]',
  Fretting: '[烦躁]',
  Terrorist: '[恐怖]',
  Halo: '[两眼冒星]',
  Shame: '[害羞]',
  Sleep: '[睡着]',
  Tired: '[冒星]',
  Mask: '[口罩]',
  ok: '[OK]',
  AllRight: '[好吧]',
  Despise: '[鄙视]',
  Uncomfortable: '[难受]',
  Disdain: '[不屑]',
  ill: '[不舒服]',
  Mad: '[愤怒]',
  Ghost: '[鬼怪]',
  Angry: '[发怒]',
  Unhappy: '[不高兴]',
  Frown: '[皱眉]',
  Broken: '[心碎]',
  Beckoning: '[心动]',
  Ok: '[好的]',
  Low: '[低级]',
  Nice: '[赞]',
  Applause: '[鼓掌]',
  GoodJob: '[给力]',
  Hit: '[打你]',
  Please: '[阿弥陀佛]',
  Bye: '[拜拜]',
  First: '[第一]',
  Fist: '[拳头]',
  GiveMeFive: '[手掌]',
  Knife: '[剪刀]',
  Hi: '[招手]',
  No: '[不要]',
  Hold: '[举着]',
  Think: '[思考]',
  Pig: '[猪头]',
  NoListen: '[不听]',
  NoLook: '[不看]',
  NoWords: '[不说]',
  Monkey: '[猴子]',
  Bomb: '[炸弹]',
  Cloud: '[筋斗云]',
  Rocket: '[火箭]',
  Ambulance: '[救护车]',
  Poop: '[便便]',
  // 错误码及提示内容
  // 通用错误码
  190001: '内部错误',
  190002: '非法状态',
  191001: '使用姿势错误',
  191002: '操作取消',
  191003: '回调失败',
  191004: '参数错误',
  191005: '请求超时',
  191006: '资源不存在',
  191007: '资源已存在',
  // 连接相关
  192001: '连接错误',
  192002: '连接超时',
  192003: '连接断开',
  192004: '协议超时',
  192005: '协议发送失败',
  192006: '请求失败',
  // 消息相关
  107319: '已超出pin数量上限',
  107320: 'PIN 消息不存在',
  107322: '重复 PIN',
  107327: '未开启 PIN 功能',
  189301: '收藏数量超限',
  189302: '收藏不存在',
  189449: '并发操作收藏失败',
  // 群相关
  109432: '没有权限',
  // 用户在线状态
  userOnlineText: '在线',
  userOfflineText: '离线',
  // 语音转文字
  voiceToTextText: '转文字',
  voiceToTextFailText: '转文字失败'
}
